module.exports = __webpack_public_path__ + "img/4.5db36cfd.jpg";